import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300Status: 'idle',
    startProcess1300Error: undefined as any,
    loadUserParamsProcess1300Status: 'idle',
    loadUserParamsProcess1300Error: undefined as any,

    process1300List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300 = createAsyncThunk('process1300Slice/startProcess1300', async ({ process1300 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300/`,
        prepareData(process1300),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300Status } = getState().process1300Slice
        return startProcess1300Status !== 'pending'
    }
})

export const loadUserParamsProcess1300 = createAsyncThunk('process1300Slice/loadUserParamsProcess1300', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300Status } = getState().process1300Slice
        return loadUserParamsProcess1300Status !== 'pending'
    }
})

const Process1300Slice = createSlice({
    name: 'process1300Slice',
    initialState,
    reducers: {
        resetstartProcess1300: (state) => {
            state.job = undefined
            state.startProcess1300Error = undefined
        },
        resetstartProcess1300Error: (state) => {
            state.startProcess1300Error = undefined
        },
        resetloadUserParamsProcess1300: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300Error = undefined
        },
        resetloadUserParamsProcess1300Error: (state) => {
            state.loadUserParamsProcess1300Error = undefined
        },
        removeFromProcess1300ListById: (state, action) => {
            state.process1300List = state.process1300List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300ListByIds: (state, action) => {
            state.process1300List = state.process1300List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300List = []
            state.startProcess1300Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300.pending, (state) => {
            state.startProcess1300Status = 'pending'
            state.startProcess1300Error = undefined
        })
        builder.addCase(startProcess1300.fulfilled, (state, action) => {
            state.startProcess1300Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300.rejected, (state, action) => {
            state.startProcess1300Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300Error = action.error.message
            } else {
                state.startProcess1300Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300.pending, (state) => {
            state.loadUserParamsProcess1300Status = 'pending'
            state.loadUserParamsProcess1300Error = undefined
        })
        builder.addCase(loadUserParamsProcess1300.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300.rejected, (state, action) => {
            state.loadUserParamsProcess1300Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300Error = action.error.message
            } else {
                state.loadUserParamsProcess1300Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300,
    resetstartProcess1300Error,
    resetloadUserParamsProcess1300,
    resetloadUserParamsProcess1300Error,
    removeFromProcess1300ListById,
    removeFromProcess1300ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300Slice.actions
export default Process1300Slice.reducer
